import { useAuth } from '@/containers/AuthContainer'
import Link from 'next/link'
import ImageOptimize from '../ImageOptimize'
interface AccountTriggerProps {
  closeModal?: () => void
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const AccountTrigger = ({ closeModal }: AccountTriggerProps) => {
  const { token, user } = useAuth()
 
  return (
    <div className='flex w-full px-3 pt-8 bg-gradient-to-b from-[#003DD4]/5 to-[#003DD4]/20 overflow-hidden'>
      
      <div className='flex items-end w-full'>

          <div className='flex-2 bnt-lg-reg text-sm flex items-end justify-between gap-2'>
            <div className='flex  flex-col'>
              {token ? (
                <>
                  <p className='text-sm pb-3 leading-5'>
                    Chào <span className='font-semibold'>{user?.name}! </span><br />
                    Nhiều ưu đãi đang chờ bạn.
                  </p>
                  <div className='flex gap-3 font-semibold pb-4'>
                    <Link
                      href='/account'
                      className='flex justify-center  items-center text-[#F00000] border border-[#F00000] w-[109px] h-[36px] rounded'
                    >
                      Trang cá nhân
                    </Link>
                    <Link
                      href={`/orders`}
                      className='flex justify-center  items-center text-[#F00000] border border-[#F00000] w-[85px] h-[36px] rounded'
                    >
                      Đơn hàng
                    </Link>
                    
                  </div>
                </>
              ) : (
                <>
                  <p className='text-sm pb-3 leading-5'>
                    Chào <span className='font-semibold'>Quý khách! </span><br />
                    Nhiều ưu đãi đang chờ bạn.
                  </p>
                  <div className='flex gap-3 font-semibold pb-4'>
                    <Link
                      href='/login'
                      className='flex justify-center items-center text-white bg-[#F00000] w-[92px] h-[36px] rounded'
                    >
                      Đăng nhập
                    </Link>
                    <Link
                      href='/search-order'
                      className='flex justify-center  items-center text-[#F00000] border border-[#F00000] w-[134px] h-[36px] rounded'
                    >
                      Tra cứu đơn hàng
                    </Link>
                    
                  </div>
                </>
              )}
            </div>
              
            <div className='flex justify-end pr-6'>
              <ImageOptimize
                src={'/assets/images/login-1.png'}
                alt={'Login'}
                width={93}
                height={100}
                loading='lazy'
                className='aspect-square object-cover'
              />
            </div>
          </div>
       
      </div>
    </div>
  )
}

export default AccountTrigger
